import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";
import { forEachRoom } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_37: DocMigration = {
  maxSchemaVersion: "0.0.37",
  apply(json: any) {
    const uniqueRoomSettingsTables = {};
    forEachRoom(json, (room) => {
      if (room.settingsOverride) {
        const existingSettingsOverride = room.settingsOverride;
        const newSettingsOverride = {};
        for (const key in existingSettingsOverride) {
          const existingSettingsUid = existingSettingsOverride[key];
          if (uniqueRoomSettingsTables[existingSettingsUid]) {
            const newSettingsUid = uid();
            newSettingsOverride[key] = newSettingsUid;
            json.tables.settings[newSettingsUid] = json.tables.settings[existingSettingsUid];
          } else {
            uniqueRoomSettingsTables[existingSettingsUid] = true;
            newSettingsOverride[key] = existingSettingsUid;
          }
        }
        room.settingsOverride = newSettingsOverride;
      }
    });

    return json;
  },
};

export default migration_0_0_37;
